import { z } from 'zod/v4';

const SHARED_STEP_TYPES = [
  'preventive_reminder',
  'first_reminder',
  'intermediate_reminder',
  'last_reminder',
] as const;

const RECOVERY_ONLY_STEP_TYPES = [
  'invoice',
  'credit_note',
  'additional_reminder',
  'formal_notice',
] as const;

const PAYMENT_PLAN_ONLY_STEP_TYPES = ['plan_creation', 'plan_update', 'plan_cancel'] as const;

export const StepTypeSchema = z.enum([
  ...RECOVERY_ONLY_STEP_TYPES,
  ...PAYMENT_PLAN_ONLY_STEP_TYPES,
  ...SHARED_STEP_TYPES,
]);
export type StepType = z.infer<typeof StepTypeSchema>;

export const RECOVERY_STEP_TYPES = [
  ...RECOVERY_ONLY_STEP_TYPES,
  ...SHARED_STEP_TYPES,
] as const satisfies readonly StepType[];

export const PAYMENT_PLAN_STEP_TYPES = [
  ...PAYMENT_PLAN_ONLY_STEP_TYPES,
  ...SHARED_STEP_TYPES,
] as const satisfies readonly StepType[];
